<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <m-form-select
          :name="$Utils.randomstring('co_civility')"
          v-model="row_co.co_civility"
          placeholder="Civilité"
          :items="[
            { text: 'Madame', value: 'mme' },
            { text: 'Monsieur', value: 'm' }
          ]"
          @input="emitChange"
        ></m-form-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <m-form-text
          :name="$Utils.randomstring('co_firstname')"
          v-model="row_co.co_firstname"
          placeholder="Prénom"
          @input="emitChange"
        ></m-form-text>
      </div>
      <div class="col-md-6">
        <m-form-text
          :name="$Utils.randomstring('co_name')"
          v-model="row_co.co_name"
          placeholder="Nom"
          @input="emitChange"
        ></m-form-text>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <m-form-text
          :name="$Utils.randomstring('co_tel1')"
          v-model="row_co.co_tel1"
          placeholder="Téléphone"
          @input="emitChange"
        ></m-form-text>
      </div>
      <div class="col-md-6">
        <m-form-select
          :name="$Utils.randomstring('co_country')"
          v-model="row_co.co_country"
          placeholder="Pays"
          :items="[
            { text: 'France', value: 'fr' },
            { text: 'Espagne', value: 'es' }
          ]"
          @input="emitChange"
        ></m-form-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr />
        <p class="petit-text color-gray2">
          En envoyant votre candidature, un compte vous sera créé.
        </p>
        <m-form-text
          :name="$Utils.randomstring('email')"
          v-model="row_co.co_email1"
          placeholder="eMail"
          @input="emitChange"
        ></m-form-text>
        <m-form-text
          type="password"
          :name="$Utils.randomstring('password')"
          v-model="row_co.co_password"
          placeholder="Mot de passe"
          @input="emitChange"
        ></m-form-text>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col">
        <hr />
        <h5 class="mt-4">Garant</h5>
        <p>
          Nous sommes partenaire de service garantme. Inscrivez-vous sur cette
          plateforme puis envoyez nous votre numéro de dossier
        </p>
        <m-form-text
          :name="$Utils.randomstring('Garant')"
          v-model="row_co.co_garantme"
          placeholder="N° dossier Garantme"
          @input="emitChange"
        ></m-form-text>
      </div>
    </div> -->
    <hr />
  </div>
</template>

<script>
export default {
  name: "account",
  components: {},
  data() {
    return {};
  },
  mounted() {
    /* if (!this.row_co.co_id) {
      this.row_co.co_civility = "0";
      this.row_co.co_country = "0";
    }
    console.log("row_co", this.row_co); */
    this.emitChange();
  },
  computed: {
    row_co() {
      if (this.$store.state.connected) return this.$store.state.user;
      return {};
    }
  },
  methods: {
    emitChange() {
      this.$emit("input", this.row_co);
    }
  }
};
</script>
